import { queryWithError } from 'lib/graphql-client';
import gql from 'graphql-tag';
import { Media, isMedia } from 'core/types/media';
import { User, isUser } from 'core/types/user';
import { UpdateProfile } from './types';
import { UserFragment } from '../fragments';

export async function updateProfilePicture(
  image: Blob,
): Promise<Media | undefined> {
  const res = await queryWithError(
    gql`
      mutation updateProfilePicture($profile: UpdateProfile!) {
        manage {
          updateProfile(profile: $profile) {
            profilePicture {
              id
              url
            }
          }
        }
      }
    `,
    {
      profile: {
        profilePicture: image,
      },
    },
  );

  if (res.errors) {
    // TODO: Handle error
    return undefined;
  }

  if (
    !res.data ||
    !res.data.manage ||
    !res.data.manage.updateProfile ||
    !res.data.manage.updateProfile.profilePicture
  ) {
    console.error('Could not find updated profile picture from return data');
    return undefined;
  }

  if (!isMedia(res.data.manage.updateProfile.profilePicture)) {
    console.error('Updated profilePicture does not conform to Media');
    return undefined;
  }

  return res.data.manage.updateProfile.profilePicture;
}

export async function updateProfile(
  profile: Pick<UpdateProfile, 'firstName' | 'lastName' | 'language'>,
): Promise<User | undefined> {
  const res = await queryWithError(
    gql`
      mutation updateProfile($profile: UpdateProfile!) {
        manage {
          updateProfile(profile: $profile) {
            ...UserFragment
          }
        }
      }
      ${UserFragment}
    `,
    {
      profile: {
        firstName: profile.firstName,
        lastName: profile.lastName,
        language: profile.language,
      },
    },
  );

  if (res.errors) {
    // TODO: Handle error
    return undefined;
  }

  if (!res.data || !res.data.manage || !res.data.manage.updateProfile) {
    console.error('Could not find profile from return data');
    return undefined;
  }

  if (!isUser(res.data.manage.updateProfile)) {
    console.error('Updated profile does not conform to User');
    return undefined;
  }

  return res.data.manage.updateProfile;
}
